import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-marketing",
  templateUrl: "./marketing.component.html",
  styleUrls: ["./marketing.component.scss"],
  animations: [
    trigger("fade", [
      state(
        "1",
        style({
          opacity: 1,
        })
      ),
      transition("* => 1", [animate("1s")]),
    ]),
  ],
})
export class MarketingComponent implements OnInit {
  constructor(public translateService: TranslocoService) {}

  ngOnInit(): void {}

  gotoForm(): void {
    console.log(this.translateService.getActiveLang());
    this.translateService.getActiveLang() == "fr"
      ? (window.location.href =
          "https://share.hsforms.com/1lUHRpI0mQuuaNbasMtUR6g53nad")
      : (window.location.href =
          "https://share.hsforms.com/1D2-du0IdQY69yYZLxB2rAw53nad");
  }
}
